import { Box } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SystemProps } from '@mui/system';
import { TournamentSettingsTitle } from 'modules/tournaments/components/TournamentSettingsTitle';
import React, { FC } from 'react';
import DOMPurify from 'dompurify';
import { useStyles } from './TournamentDescription.styles';

type TournamentDescriptionProps = {
  content: string;
} & SystemProps<Theme>;

export const TournamentDescription: FC<TournamentDescriptionProps> = ({ content, ...rest }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root} {...rest}>
      <TournamentSettingsTitle>Tournament Description</TournamentSettingsTitle>
      <Box
        className={classes.content}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content, { ADD_ATTR: ['target'] }) }}
      />
    </Box>
  );
};
